// src/pages/About.jsx

import React from 'react';
import { Box, Container, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import brandIllustration from '../assets/brand.png';

function About() {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="md">
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ x: -30, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <Typography variant="h3" sx={{ mb: 2 }}>
                About MindMapper AI
              </Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                MindMapper AI is a next-generation platform dedicated to helping people explore 
                and understand the world of dreams, guided by advanced artificial intelligence.
              </Typography>
              <Typography variant="body1">
                Our mission is to empower individuals to improve mental wellness 
                through reflective dream analysis and personalized meditation. 
                Whether you’re a curious dreamer or a mindfulness enthusiast, 
                our app is designed to offer an intuitive, fulfilling experience.
              </Typography>
            </motion.div>
          </Grid>
          <Grid item xs={12} md={6}>
            <motion.div
              initial={{ x: 30, opacity: 0 }}
              whileInView={{ x: 0, opacity: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <Box
                component="img"
                src={brandIllustration}
                alt="About MindMapper AI"
                sx={{ width: '100%', borderRadius: 4 }}
              />
            </motion.div>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default About;
